if (!customElements.get('product-form')) {
    customElements.define('product-form', class ProductForm extends HTMLElement {
        constructor() {
            super();

            this.form = this.querySelector('form');
            this.form.querySelector('[name=id]').disabled = false;
            this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
            this.reinsuranceCart = document.getElementById('reinsuranceCart');
            this.cart = document.querySelector('cart-drawer');
            this.submitButton = this.querySelector('[type="submit"]');
            if (document.contains(this.querySelector('.loading-overlay__spinner'))) {
                this.spinner = this.querySelector('.loading-overlay__spinner');
            }
            this.quick_add = this.querySelector('.quick_add');
            if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

            this.openCart = new CustomEvent('open-cart');
            this.closeCart = new CustomEvent('close-cart');
        }

        onSubmitHandler(e) {

            e.preventDefault();

            if (this.submitButton.getAttribute('disabled') === '') return;

            this.handleErrorMessage();

            this.submitButton.setAttribute('disabled', '');
            this.submitButton.classList.add('loading');

            if (document.contains(this.spinner)) {
                this.spinner.classList.remove('hidden');
            }


            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];

            const formData = new FormData(this.form);


            if (this.cart) {
                formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
                formData.append('sections_url', window.location.pathname);
                this.cart.setActiveElement(document.activeElement);
            }

            config.body = formData;

            fetch(`${routes.cart_add_url}`, config)
                .then((response) => response.json())
                .then((response) => {

                    if (response.status) {
                        this.handleErrorMessage(response.description);

                        this.submitButton.setAttribute('disabled', '');
                        this.error = true;
                        return;
                    } else if (!this.cart) {
                        window.location = window.routes.cart_url;
                        return;
                    }

                    this.error = false;

                    this.cart.renderContents(response);

                    //Couleur du bg du panier.
                    if (response.quantity > 0) {
                        this.cart.style.background = '#ffffff';
                        this.reinsuranceCart.style.display = 'flex';
                    } else {
                        this.cart.style.background = '#FF7B51';
                        this.reinsuranceCart.style.display = 'none';
                    }

                    // Ouvrir le panier avec Alpine.
                    window.dispatchEvent(this.openCart);
                })
                .catch((e) => {
                    console.error(e);
                })
                .finally(() => {
                    this.submitButton.classList.remove('loading');
                    if (document.contains(this.spinner)) {
                        this.spinner.classList.add('hidden');
                    }

                    if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
                    this.submitButton.removeAttribute('disabled');
                });
        }

        handleErrorMessage(errorMessage = false) {
            this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
            if (!this.errorMessageWrapper) return;
            this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

            this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

            if (errorMessage) {
                this.errorMessage.textContent = errorMessage;
            }
        }
    });
}